import styled from 'styled-components';
import { Button as ButtonAtom } from 'components/atoms/button';

// TODO:: Make this the default button import for the project and take types for it here instead of importing from ANT.
// While doing that, move this export as `<Button type="default|primary|dashed|tertiary" />` instead of `<TertiaryButton />`
export const TertiaryButton = styled(ButtonAtom)`
  background-color: transparent;
  border: solid 1px var(--brand-color);
  color: var(--brand-color);
  box-shadow: var(--shadow-highlight)
    rgba(var(--brand-color-in-rgb), var(--shadow-highlight-color-opacity));

  /* TODO:: Adding the !important here because we have a global style that has a !important.
  while moving to globals to styled, make sure this is addressed */
  &:hover {
    background-color: var(--brand-color) !important;
    color: var(--white-100);
    fill: var(--white-100);
  }
`;
